import React, { ElementType, FC } from 'react';
import { Box, Button, Link, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import theme from 'theme';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  component?: ElementType;
}

const styles = {
  text: {
    display: 'block',
    textDecoration: 'none',
    fontWeight: 'bold',
  },
  link: {
    '&:hover': {
      color: theme.palette.grey[900],
    },
  },
} as const;

const GridSectionTitle: FC<Props> = ({ title, component }) => {
  const { t } = useTranslation();

  const textClasses = component ? { ...styles.text, ...styles.link } : styles.text;

  return (
    <Box marginTop={5} marginBottom={1}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid>
          {component ? (
            <Link
              noWrap
              variant="h4"
              color="textSecondary"
              underline="none"
              component={component}
              sx={textClasses}
            >
              {title}
            </Link>
          ) : (
            <Typography
              noWrap
              variant="h4"
              color="textSecondary"
              underline="none"
              component={component}
              sx={textClasses}
            >
              {title}
            </Typography>
          )}
        </Grid>
        {component && (
          <Grid>
            <Button component={component} variant="contained">
              {t('admin:allPosts')}
            </Button>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default GridSectionTitle;
